<template>
  <transition name="lightbox">
    <div class="lightbox-mask">
      <div class="lightbox-wrapper" @click.self="$emit('close')">
        <div class="lightbox-container">
          <div class="lightbox-body">
            <slot name="body">
            </slot>
          </div>
        </div>
        <div class="lightbox-close" @click.stop="$emit('close')">
          <slot name="close">
            <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
            </svg>
          </slot>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  data () {
    return {
      //msg: 'Welcome to Your Vue.js App'
    }
  }
}
</script>

<style lang="scss">
  .lightbox-container{
    background-color: transparent;
    max-width: 600px;
    width: 80%;
  }
  .lightbox-body ul{
    margin:0;
    padding:0;
    list-style: none;
  }
  .lightbox-body ul li{
    margin: 20px auto;
  }
  .lightbox-body ul img{
    width: 100%;
  }
  .lightbox-close{
    position: absolute;
    top: 3%;
    right: 3%;
    width:35px;
    height:35px;
    cursor: pointer;
  }
  .lightbox-close:hover{
    opacity: 0.8;
  }
  .lightbox-close svg{
    width:100%;
    height: 100%;
    fill: white;
  }
  .lightbox-mask{
    position: absolute;
    z-index: 200;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
    display: flex;
    transition: opacity .3s ease;
  }
  .lightbox-wrapper {
    flex-grow: 1;
    display: flex;
  }
  .lightbox-container{
    width: 300px;
    margin: 0px auto;
    padding: 15px;
    background-color: #fff;
    transition: all .3s ease;
    font-family: Helvetica, Arial, sans-serif;
    align-self: center;
    justify-self: center;
    flex-grow: 1;
  }
</style>


// WEBPACK FOOTER //
// Lightbox.vue?32c0c663